<template>
  <div class="tw-mb-6">
    <slot name="checkbox" />
    <slot name="radio" />
    <slot name="label">
      <label
        :for="inputId"
        v-if="label"
        :class="[{ 'tw-mb-2': !($slots.checkbox || $slots.radio) }, labelClass]"
        v-html="label"
      />
    </slot>
    <slot />
    <slot name="append-content"></slot>
    <div class="valid-feedback" v-if="successes && success.length">
      <div v-for="(success, s) in successes" :key="s">
        {{ success }}
      </div>
    </div>
    <div class="invalid-feedback" v-if="errors && errors.length">
      <div v-for="(error, e) in errors" :key="e">
        {{ error }}
      </div>
    </div>
    <small v-if="description" class="ms-1 form-text text-muted">{{ description }}</small>
  </div>
</template>

<script>
export default {
  name: "FormGroup",
  props: {
    description: String,
    inputId: String,
    label: String,
    labelClass: String,
    errors: [Array, Boolean],
    successes: [Array, Boolean],
    validated: Boolean,
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.invalid-feedback,
.valid-feedback {
  display: block;
  font-size: 0.6875rem;
}
</style>
